import React from "react";
import { Lock } from "lucide-react";
import { Button } from "../../components/button";
import { useTranslation } from "react-i18next";
import { useLogoutUser } from "../../hooks/useLogoutUser";

const UnAuthorized: React.FC = () => {
  const { t } = useTranslation();

  const { logoutUser } = useLogoutUser();

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-purple-primary/10 dark:bg-purple-primary/40">
      <div className="text-center p-4 lg:p-8 bg-white shadow-md w-[90%] sm:w-1/2 lg:w-[30%] rounded-lg gap-3 flex flex-col">
        <div className="max-w-max mx-auto p-2 rounded-full bg-red-100 shadow-lg">
          <Lock className="text-red-500 w-10 h-10 " />
        </div>

        <h1 className="text-7xl font-bold text-red-500">401</h1>

        <h2 className="text-2xl font-semibold text-gray-800 ">
          {t("unAuthorized")}
        </h2>

        <p>{t("sorryPageDoesntExist")}</p>

        <div>
          <Button
            onClick={logoutUser}
            className="bg-transparent ring-1 ring-red-500 text-red-500 hover:bg-transparent"
          >
            {t("backToLogin")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UnAuthorized;
